<template>
  <div id="app">
    <Main title="CCM Elefante de Olinda"/>
  </div>
</template>

<script>
import Main from './components/Main.vue'
export default {
  name: 'app',
  components: {
    Main
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #A81317;
}
</style>



// WEBPACK FOOTER //
// src/App.vue